import { render, staticRenderFns } from "./editBrank.vue?vue&type=template&id=867f93b8&scoped=true"
import script from "./editBrank.vue?vue&type=script&lang=js"
export * from "./editBrank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867f93b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('867f93b8')) {
      api.createRecord('867f93b8', component.options)
    } else {
      api.reload('867f93b8', component.options)
    }
    module.hot.accept("./editBrank.vue?vue&type=template&id=867f93b8&scoped=true", function () {
      api.rerender('867f93b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplier/coupons/editBrank.vue"
export default component.exports